import { ShareOptionVariant } from './interfaces';
import { IconVariants } from '../Icon/interfaces';

interface ShareOptionsInfosInterface {
  readonly name: string;
  readonly clickedName?: string;
  readonly icon: IconVariants;
  readonly shareLink?: string;
}

export const getShareOptionsInfo = (
  variant: ShareOptionVariant,
  url: string,
  text?: string
): ShareOptionsInfosInterface => {
  const shareOptionsData: {
    [key in ShareOptionVariant]: ShareOptionsInfosInterface;
  } = {
    eMail: {
      name: 'E-Mail',
      icon: 'user/mail',
      shareLink: `mailto:?&subject=${text}&body=${text && `${text}%0A`}${url}`,
    },
    facebook: {
      name: 'Facebook',
      icon: 'action/facebook',
      shareLink: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
    },
    linkedIn: {
      name: 'LinkedIn',
      icon: 'action/linkedin',
      shareLink: `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=Enercity&summary=${text}&source=Enercity`,
    },
    twitter: {
      name: 'Twitter',
      icon: 'action/twitter',
      shareLink: `https://twitter.com/intent/tweet?text=${
        text && `${text}%0A`
      }${url}`,
    },
    xing: {
      name: 'Xing',
      icon: 'action/xing',
      shareLink: `https://www.xing.com/app/user?op=share&url=${url}&title=${text}`,
    },
    linkCopy: {
      name: 'Link kopieren',
      clickedName: 'Link kopiert',
      icon: 'action/link',
    },
  };

  return shareOptionsData[variant];
};
